// @ts-nocheck
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import getOrderChangeRequestAvailability from "@store/Framework/Common/Utilities/OrderChangeRequest/getOrderChangeRequestAvailability";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { contentWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderChangeUnavailableAlertStyles {
    infosBox?: InfosBoxProps;
}

const styles: OrderChangeUnavailableAlertStyles = {
    infosBox: {
        type: "error",
        extendedStyles: {
            wrapper: {
                css: css`
                    ${contentWidthStyles()};
                    margin-top: ${pxToRem(20)};
                `,
            },
        },
    },
};

const OrderChangeUnavailableAlert: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    const { canRequestOrderChange, disabledMessage } = getOrderChangeRequestAvailability(order);

    if (canRequestOrderChange || !disabledMessage) {
        return null;
    }

    return (
        <InfosBox {...styles.infosBox} data-test-selector="orderChangeUnavailableAlert">
            {disabledMessage}
        </InfosBox>
    );
};

export default OrderChangeUnavailableAlert;
